import {Inject, Injectable} from '@angular/core';
import {FirebaseApp} from 'angularfire2';
import {AuthService} from './auth.service';
import {AngularFireDatabase, snapshotChanges} from 'angularfire2/database';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Partner} from '../classes/partner';
import * as firebase from 'firebase';
import {Observable} from 'rxjs/Rx';

@Injectable()
export class PartnerService {
  private sdkDb: any;
  private userId: string = null;
  private userType: string = null;

  constructor(private db: AngularFireDatabase, @Inject(FirebaseApp) fb: FirebaseApp, private authService: AuthService) {
    this.sdkDb = fb.database();
    this.authService.getCurrentUser().subscribe(user => {
      if  (user) {
        this.userId = user.uid;
      } else {
        user = null;
      }
    });
    this.authService.getUserType().subscribe(type => {this.userType = type; });
  }

  async addPartner(partner: Partner) {
    if (this.userType === 'admin') {
      partner.creationDate = firebase.database.ServerValue.TIMESTAMP;
      partner['owner'] = this.userId;
      const key = this.db.createPushId();
      console.log("EMAIL", partner.email);
      return await this.authService.fetchProvidersForEmail(partner.email).then(e => {
          if (e.length > 0){ 
            throw 'exists'
          }
          return this.sdkDb.ref(`admin/pendences/newPartner/${key}`).update(partner)
        })
    }
  }
  

  getAllPartners() {
    if (this.userType === 'admin') {
      return this.db.list<Partner>(`partners`).valueChanges();
    }
    return Observable.of([]);
  }
  // getPartnerByEmail(email: string) {
  //   return Observable.fromPromise(this.sdkDb.ref('`partnersPerUser/${this.userID}`').orderByChild('email').equalTo(email)
  //     .once('value').then(snap => {return this.db.object(`partners/${snap.key}`)   }))
  // }
}
//     console.log(snap);
//     return snap;
//   }).take(1)}))
// return this.db.object('admin/pendences/newPartner/key/').set(partner).then(resp => {
//   return this.db.list('admin/pendences/newPartner/key').valueChanges(['child_added']).map(snap => {
//     console.log(snap);
//     return snap;
//   }).take(1)});
// }



// WEBPACK FOOTER //
// C:/Users/bruna/Desktop/nuresp/src/app/shared/services/partner.service.ts